<ion-item
  my-item
  lines="none"
  (click)="select.emit(item)"
  [style.background]="item.colorCode || '#F4F9FA'"
>
  <ion-avatar slot="start">
    <ion-img [src]="item.icon"></ion-img>
  </ion-avatar>
  <ion-label>
    <div class="item-name">{{ item.name }}</div>
    <p>
      <ion-text
        color="dark"
        *ngFor="let cat of item.categoryNodes; let $index = index"
        [class.font-bold]="$index == 0 && item?.categoryNodes.length > 1"
      >
        {{ cat.name }}
        <span [hidden]="$index + 1 === item?.categoryNodes.length"> • </span>
      </ion-text>
    </p>
  </ion-label>
  <ion-icon
    style="font-size: 19px"
    color="medium"
    *ngIf="!isSelected"
    class="icon-border"
    [src]="'./assets/forward-arrow.svg'"
    slot="end"
  ></ion-icon>
  <ion-icon
    *ngIf="isSelected"
    color="primary"
    [name]="'checkmark-circle'"
    slot="end"
  ></ion-icon>
</ion-item>
